// Tarja de inadimplência, compartilhada por toda a sessão.
//
// O valor não é buscado: vem de carona no header `X-Overdue-Alert` que o
// backend põe em toda resposta da API (BDM-913). Antes ele era calculado só no
// login e ficava congelado no localStorage — quem ficava inadimplente durante a
// sessão não via aviso nenhum, e quem pagava continuava vendo até relogar.
//
// O nível ('warning' a partir do 3º dia de atraso, 'critical' a partir do 13º)
// é decidido pelo backend; aqui só se guarda o que ele mandou (BDM-1028).
//
// O localStorage segue sendo usado só como valor inicial, para a tarja não
// piscar entre o carregamento da página e a primeira resposta da API.

const STORAGE_KEY = 'overdue_alert_level';

export const OVERDUE_ALERT_NONE = 'none';
export const OVERDUE_ALERT_WARNING = 'warning';
export const OVERDUE_ALERT_CRITICAL = 'critical';

const LEVELS = [OVERDUE_ALERT_NONE, OVERDUE_ALERT_WARNING, OVERDUE_ALERT_CRITICAL];

const normalize = (value) => LEVELS.includes(value) ? value : OVERDUE_ALERT_NONE;

const readStored = () => {
    try {
        return normalize(localStorage.getItem(STORAGE_KEY));
    } catch (error) {
        return OVERDUE_ALERT_NONE;
    }
};

let level = readStored();
const listeners = new Set();

export const setOverdueAlert = (value) => {
    const next = normalize(value);

    localStorage.setItem(STORAGE_KEY, next);

    if (next === level) return;

    level = next;
    listeners.forEach((listener) => listener(level));
};

export const getOverdueAlertLevel = () => level;

export const hasOverdueAlert = () => level !== OVERDUE_ALERT_NONE;

// Formato subscribe/getSnapshot esperado por useSyncExternalStore.
export const subscribeOverdueAlert = (listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const resetOverdueAlert = () => setOverdueAlert(OVERDUE_ALERT_NONE);
